<template>
  <main class="route-page">
    <section class="route-page__content">
      <h1 v-if="routePage.title" class="route-page__heading">
        {{ routePage.title }}
      </h1>

      <div v-if="routePage.price" class="route-page__price">
        {{ routePage.price }}
      </div>

      <p v-if="routePage.introduction" class="route-page__preamble">
        {{ routePage.introduction }}
      </p>
    </section>

    <div v-if="routePage.imageUrl" class="route-page__image">
      <img
          :src="routePage.imageUrl"
          :srcset="routePage.imageSrcSet || undefined"
          :sizes="routePage.imageSizes || undefined"
          :alt="routePage.imageAltText"/>
    </div>

    <section
        v-for="(block, index) in routePage.upperBlocks"
        :key="`upper-${block.blockType}-${index}`"
        class="route-page__content">
      <h2 v-if="block.title">{{ block.title }}</h2>
      <div v-if="block.text" v-html="block.text"></div>
    </section>

    <section class="route-page__content" v-if="routePage.ticket">
      <RouteTable :ticket="routePage.ticket"/>
    </section>

    <section
        v-for="(block, index) in routePage.lowerBlocks"
        :key="`lower-${block.blockType}-${index}`"
        class="route-page__content">
      <h2 v-if="block.title">{{ block.title }}</h2>
      <div v-if="block.text" v-html="block.text"></div>
    </section>
  </main>
</template>

<script setup lang="ts">
import RouteTable from "@features/Pages/RoutePage/Components/RouteTable/RouteTable.vue";

defineProps<{
  routePage: RoutePagePayload;
}>();

</script>
